import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { tr } from 'date-fns/locale';
import { SocketService } from 'src/app/core/services/socket.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-alerts-in-process-alert',
  templateUrl: './alerts-in-process-alert.component.html',
  styleUrls: ['./alerts-in-process-alert.component.scss'],
})
export class AlertsInProcessAlertComponent implements OnDestroy, OnChanges {
  @Input() isOpen = false;
  @Output() closeModal = new EventEmitter<void>();
  @Output() openProcessModal = new EventEmitter<void>();
  secondsLeft: number = 15;
  interval: any;
  progressPercentage = 100;
  private timer: any;

  constructor(
    private snackBar: MatSnackBar,
    private socket: SocketService,
    private userService: UserService
  ) {
    this.startTimer();

    // this.socket.socket.on('open_modal_accept_alert', (data) => {
    //   console.log('open_modal_accept_alert', data);
    //   if (
    //     data.idAnalista.toString() ==
    //     this.userService.currentUser?._id.toString()
    //   ) {
    //     this.isOpen = true;
    //     console.log(
    //       'xxxxxxxxxxxxxxxxxx',
    //       data.idAnalista,
    //       this.userService.currentUser?._id,
    //       this.isOpen
    //     );
    //   }
    // });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isOpen']) {
      if (this.isOpen) {
        this.startTimer();
        console.log('Modal opened ngOnChanges, starting timer');
      } else {
        this.stopTimer();
      }
    }
  }
  ngOnDestroy() {
    this.stopTimer();
    // this.socket.socket.off('open_modal_accept_alert');
  }

  openModal() {
    this.isOpen = true;
    this.startTimer();
    console.log('Modal opened openModal, starting timer');
  }
  startTimer() {
    // Reiniciar valores
    this.secondsLeft = 15;
    this.progressPercentage = 100;

    this.timer = setInterval(() => {
      this.secondsLeft--;
      this.progressPercentage = (this.secondsLeft / 15) * 100;

      if (this.secondsLeft <= 0) {
        this.closeDueToTimeout();
      }
    }, 1000);
  }
  closeDueToTimeout() {
    this.stopTimer();
    this.closeModal.emit();
    // this.showTimeoutMessage();
  }

  stopTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  showTimeoutMessage() {
    this.snackBar.open(
      'El tiempo de espera ha culminado, la alerta se ha enviado a otro analista y quedará como strike',
      'Cerrar',
      {
        duration: 5000,
        panelClass: ['snackbar-timeout'],
      }
    );
  }

  close() {
    this.stopTimer();
    this.closeModal.emit();
    this.closeDueToTimeout();
    this.socket.socket.emit('refused_alert', {
      userId: this.userService.currentUser._id,
    });
  }

  onTakeAlert() {
    this.stopTimer();
    this.openProcessModal.emit();
    this.socket.socket.emit('accept_alert', {
      userId: this.userService.currentUser._id,
    });
  }
}
